"use strict";

var _classCallCheck = require("/Users/ganjarhadiatna/Projects/React/erxes-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ganjarhadiatna/Projects/React/erxes-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/ganjarhadiatna/Projects/React/erxes-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/ganjarhadiatna/Projects/React/erxes-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _PopoverStore = require("./PopoverStore");

var PopoverWrapper = /*#__PURE__*/function (_react$default$PureCo) {
  _inherits(PopoverWrapper, _react$default$PureCo);

  var _super = _createSuper(PopoverWrapper);

  function PopoverWrapper() {
    _classCallCheck(this, PopoverWrapper);

    return _super.apply(this, arguments);
  }

  _createClass(PopoverWrapper, [{
    key: "hidePopovers",
    value: function hidePopovers() {
      _PopoverStore.popoverStore.hide();
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", (0, _extends2.default)({
        onClick: this.hidePopovers,
        onTouchEnd: this.hidePopovers
      }, this.props), this.props.children);
    }
  }]);

  return PopoverWrapper;
}(_react.default.PureComponent);

exports.default = PopoverWrapper;
(0, _defineProperty2.default)(PopoverWrapper, "propTypes", {
  children: _propTypes.default.node
});
(0, _defineProperty2.default)(PopoverWrapper, "defaultProps", {
  children: []
});